import React, { useContext, useRef } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { Controller, FieldError, useFormContext } from 'react-hook-form'
import Select, { CSSObjectWithLabel } from 'react-select'
import './index.scss'
import { OptionModel } from '@Entities/lib'

interface CellDropdownProps {
    name: string
    value: number | string
    onSelectedValueChanged: (newValue: OptionModel) => void
}

const CellDropdown = ({ name, value, onSelectedValueChanged }: CellDropdownProps) => {
    const { control } = useFormContext()
    const { libStore } = useContext<RootStore>(StoresContext)

    const writerRoleOptions = libStore.writerRoles

    const controllerDefaultValue = () => writerRoleOptions.find((option) => option.label === value)

    const configureStyle = (baseStyles: CSSObjectWithLabel, fieldError: FieldError | undefined): CSSObjectWithLabel => {
        const updatedStyles: CSSObjectWithLabel = { ...baseStyles }
        updatedStyles.border = !fieldError ? '1px solid grey' : '2px solid red'
        updatedStyles.boxShadow = 'none'
        return updatedStyles
    }

    const selectRef = useRef<any>(null)

    return (
        <div className="cell-dropdown-container">
            <Controller
                name={name}
                control={control}
                shouldUnregister
                defaultValue={controllerDefaultValue()}
                render={({ field, fieldState }) => {
                    const { ref, ...restOfFieldProps } = field

                    return (
                        <>
                            <Select
                                ref={(currentRef: any) => {
                                    ref(currentRef)
                                    selectRef.current = currentRef
                                }}
                                styles={{
                                    control: (baseStyles: CSSObjectWithLabel): CSSObjectWithLabel =>
                                        configureStyle(baseStyles, fieldState.error),
                                }}
                                menuPosition="fixed"
                                className="select"
                                {...restOfFieldProps}
                                options={writerRoleOptions}
                                onChange={(e: OptionModel) => {
                                    field.onChange(e)
                                    onSelectedValueChanged(e)
                                    selectRef.current && setTimeout(() => selectRef.current.blur())
                                }}
                                placeholder="Select a role"
                            />

                            {fieldState.error && <span className="error-message">{fieldState.error.message}</span>}
                        </>
                    )
                }}
            />
        </div>
    )
}

export default CellDropdown
